  <div class="min-max--container vertical" *ngIf="false && showSKUAvailableQuantity" [ngClass]="fontSize">
    <div  [ngClass]="classes">
      <span>Available Quantity: </span><strong class="font-weight-normal">{{ availableQuantity }}</strong>
    </div>
  </div>
